import {
  ActionStore,
  createAction,
  KeyStore,
  LazyRemoteCollectionStore,
  on,
  ParamsStore,
  SOFTLINE_SERVICE_UUID,
  StoreFeature,
} from '@softline/core';
import { AuftragResourceService } from '../services/auftrag-resource.service';
import { KopfauBean } from '../types/kopfau-bean';

export type State = LazyRemoteCollectionStore.State<KopfauBean>;
const store = LazyRemoteCollectionStore.create<KopfauBean>();

export const getters = {
  ...store.getters,
};

export const mutations = {
  ...store.mutations,
};

export const actions = {
  ...store.actions,
  complete: createAction<
    State,
    { id: number; station: KopfauBean; token?: string },
    KopfauBean
  >('station/complete'),
};

export const feature: StoreFeature<State> = {
  initialState: {
    ...store.feature.initialState,
  },
  getters: [...store.feature.getters],
  mutations: [...store.feature.mutations],
  actions: [
    ...store.feature.actions,
    on(actions.complete, async ({ injector, featureName, commit, params }) => {
      const service = injector.get(AuftragResourceService);
      const token = params.token ?? injector.get(SOFTLINE_SERVICE_UUID)();
      commit(featureName, KeyStore.mutations.add, token);
      commit(featureName, ParamsStore.mutations.add, { key: token, params });

      const result = await ActionStore.handleActionState(
        service.completeStation(params.id, params.station),
        featureName,
        commit,
        actions.complete.name,
        token
      );

      commit(featureName, mutations.update, result);
      commit(featureName, mutations.resetChange, result.id);
      return result;
    }),
  ],
};
